export default {
  init() {
    const dropcap = document.querySelector('.ms-rich-text__dropcap');

    if (!dropcap || dropcap.tagName.toLowerCase() !== 'canvas') {
      return;
    }

    this.startListener(dropcap);
  },
  startListener(dropcap) {
    const darkBlue = '#052f67';
    const white = '#ffffff';
    const letter = dropcap.innerHTML.trim().charAt(0);
    const ctx = dropcap.getContext('2d');
    ctx.font = '400px "Avenir", sans-serif';
    ctx.lineWidth = 16;
    ctx.strokeStyle = darkBlue;
    ctx.fillStyle = white;
    ctx.textAlign = 'center';
    ctx.strokeText(`${letter}`, 200, 320);
    ctx.fillText(`${letter}`, 200, 320);
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/components/dropcap.js